import React, { Component } from 'react';
import { Braintree, HostedField } from 'react-braintree-fields';
import cx from 'classnames';
import classes from './CheckoutForm.module.scss';
import cvvIcon from '../../../assets/images/checkout/cvvIcon.png';
class CheckoutForm extends Component {
  constructor(props) {
    super(props);
    this.numberField = React.createRef();
    this.braintree = React.createRef();
    [
      'onError',
      'getToken',
      'onCardTypeChange',
      'onAuthorizationSuccess',
    ].forEach((prop) => (this[prop] = this[prop].bind(this)));
  }

  state = {};

  onError(error) {
    this.setState({ error });
  }

  getToken = () => {
    const token = this.tokenize({
      billingAddress: {
        firstName: this.props.personalInfo.firstName,
        lastName: this.props.personalInfo.lastName,
        streetAddress: this.props.personalInfo.address,
        postalCode: this.props.personalInfo.zip,
      },
      number: {
        container: '#card-number',
        supportedCardBrands: {
          visa: true,
          mastercard: true,
          'american-express': true,
          'diners-club': false,
          discover: true,
          jcb: false,
          'union-pay': false,
          maestro: false,
          elo: false,
          mir: false,
          hiper: false,
          hipercard: false,
        },
      },
    });
    token
      .then((token) => {
        this.props.onClickCheckoutSubmit('Success', token);

        return this.setState({ token, error: null });
      })
      .catch((error) => {
        this.props.onClickCheckoutSubmit('Error', error);
        return this.setState({ token: null, error });
      });
  };

  onCardTypeChange({ cards }) {
    if (1 === cards.length) {
      const [card] = cards;

      this.setState({ card: card.type });

      if (card.code && card.code.name) {
        this.cvvField.setPlaceholder(card.code.name);
      } else {
        this.cvvField.setPlaceholder('CVV');
      }
    } else {
      this.setState({ card: '' });
      this.cvvField.setPlaceholder('CVV');
    }
  }

  state = {
    numberFocused: false,
  };

  componentDidMount() {}

  onAuthorizationSuccess() {
    this.numberField.current.focus();
  }

  render() {
    return (
      <>
        <div className={classes.checkoutForm}>
          <Braintree
            ref={this.braintree}
            authorization={this.props.authorization}
            onAuthorizationSuccess={this.onAuthorizationSuccess}
            onError={this.onError}
            getTokenRef={(t) => (this.tokenize = t)}
            onCardTypeChange={this.onCardTypeChange}
            styles={{
              input: {
                'font-size': '10px',
                'font-family': 'sans-serif',
                color: '#7d6b6b',
                'letter-spacing': '0.5px',
                height: '30px',
              },
              ':focus': {
                color: 'black',
              },
            }}
          >
            <div>
              <div className={classes.formRow}>
                <div className={classes.formFull}>
                  <i
                    className={cx(classes.formIcon, 'fa fa-credit-card')}
                    aria-hidden="true"
                  ></i>
                  <HostedField
                    type="number"
                    onBlur={() => this.setState({ numberFocused: false })}
                    onFocus={() => this.setState({ numberFocused: true })}
                    className={this.state.numberFocused ? 'focused' : ''}
                    placeholder="Credit Card"
                    ref={this.numberField}
                  />
                </div>
              </div>
              <div className={classes.formRow}>
                <div className={classes.formRowHalf}>
                  <i
                    className={cx(classes.formIcon, 'fa fa-calendar')}
                    aria-hidden="true"
                  ></i>
                  <HostedField type="expirationDate" placeholder="MM / YYYY" />
                </div>

                <div className={classes.formRowHalf}>
                  <img
                    className={classes.cvvIcon}
                    src={cvvIcon}
                    alt="CVV Icon"
                  />
                  <HostedField
                    type="cvv"
                    placeholder="CVV"
                    ref={(cvvField) => {
                      this.cvvField = cvvField;
                    }}
                  />
                </div>
              </div>
            </div>
          </Braintree>
          {this.props.validationErrorMsg && (
            <div
              className={cx(
                classes.formError,
                this.props.validation === false ? classes.active : ''
              )}
            >
              {this.props.validationErrorMsg}
            </div>
          )}
        </div>
        {this.props.children}
        <div className={classes.submitForm}>
          <button onClick={() => this.getToken()}>Purchase</button>
          <p className={classes.disclaimer}>
            Ticket brokers are not eligible for this offer. In connection with
            your purchase, you will receive ticket-related commercial emails
            from nationals.com. You may unsubscribe at any time. All sales are
            final. There are no refunds or exchanges. All 2021 access, benefits,
            promotions, seating locations, and events (including, without
            limitation, location, dates and times) are subject to change without
            notice based on the ongoing developments of the COVID-19 pandemic.{' '}
            {/* For terms & conditions of the 50% Bonus Credit offer, please{' '}
            <a
              href="http://www.nationals.com/bonusterms"
              target="_blank"
              rel="noopener noreferrer"
            >
              click here
            </a> */}
            For additional terms and conditions that govern your purchase
            please{' '}
            <a
              href="https://www.mlb.com/nationals/tickets/info/ticket-terms-conditions"
              target="_blank"
              rel="noopener noreferrer"
            >
              click here
            </a>
            .
          </p>
        </div>
      </>
    );
  }
}

export default CheckoutForm;
